import React from 'react';
import { TaxStat } from '../taxComplianceTypes';
import styles from './TaxStatCard.module.css';

interface TaxStatCardProps {
  stat: TaxStat;
  icon: React.ReactNode;
}

export const TaxStatCard: React.FC<TaxStatCardProps> = ({ stat, icon }) => {
  return (
    <div className={styles.card}>
      {stat.badge && (
        <span
          className={styles.badge}
          style={{ color: stat.badge.color, background: stat.badge.bg }}
        >
          {stat.badge.text}
        </span>
      )}
      <div className={styles.iconWrapper} style={{ background: stat.iconBg }}>
        <span style={{ color: stat.iconColor }}>{icon}</span>
      </div>
      <p className={styles.label}>{stat.label}</p>
      <p className={styles.subtext}>{stat.subtext}</p>
      <p className={styles.value} style={{ color: stat.valueColor }}>
        {stat.value}
      </p>
    </div>
  );
};
